import { useMutation } from '@tanstack/react-query';
import { setAxiosAuth } from 'utils';
import { postInsurance } from 'core/api/booking/booking.api';

export const usePostInsurance = ({ accessToken = '' }) => {
  setAxiosAuth(accessToken);

  return useMutation({
    mutationFn: postInsurance,
    retry: 0,
  });
}
